import { render } from "./NotePopup.vue?vue&type=template&id=3e3cdcba&scoped=true"
import script from "./NotePopup.vue?vue&type=script&lang=js"
export * from "./NotePopup.vue?vue&type=script&lang=js"

import "./NotePopup.vue?vue&type=style&index=0&id=3e3cdcba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e3cdcba"]])

export default __exports__